var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div'),_c('div',{staticClass:"main_footer"},[_c('div',{staticClass:"footer_btn"},[_vm._v("绑定电子合同")])])])
}]

export { render, staticRenderFns }